import { render, staticRenderFns } from "./GifCom.vue?vue&type=template&id=9a6a72d2&scoped=true"
import script from "./GifCom.vue?vue&type=script&lang=js"
export * from "./GifCom.vue?vue&type=script&lang=js"
import style0 from "./GifCom.vue?vue&type=style&index=0&id=9a6a72d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6a72d2",
  null
  
)

export default component.exports